<emoji-mart
  title="Pick your emoji…"
  emoji="point_up"
  (emojiClick)="emojiClicked($event)"
></emoji-mart>
